import React, { useState, useEffect } from "react";

export const svg = `<svg width="64" height="33" viewbox="0 0 64 33" viewBox="0 0 64 33" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M18 9.5H19V12.5H18V9.5Z" fill="currentColor"></path><path d="M6.55228 8.05222H8.40303V11.7537H6.55228V8.05222Z" fill="currentColor"></path><path d="M9.01995 15.4552H6.55228V19.1567H9.01995V15.4552Z" fill="currentColor"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M11.796 2.5H1V24.5H15V25.5H9.63682L10.8706 28.5846H19V21.5H13V20.5H21V27.5H24V20.5H27.5L29.995 13.6045H34.9303L37.5 20.5H41V27.5H44V20.5H46V28.5H54.0199L55.2886 25.5H50V24.5H63V17.5H60V9.5H63V2.5H51.5871L49 6.5V13.5H48V4.5H14L13.3383 6.20149L11.796 2.5ZM16.1979 6.5L13.9553 10.2114L13.9552 17.5H18V15.5H19V17.5H22.592V10.2114L20.7484 6.5H16.1979ZM23 6.50001V9.50001H26V17.5H26.4586L28.5918 11.6045H29V9.5H32V6.5L23 6.50001ZM33 6.5V9.5H36V11.6045H36.3194L38.5164 17.5L39 17.5V9.5H42V6.5H33ZM43 17.5L50 17.5V15.5H46V6.5H43V17.5ZM51 17.5H53.2115L54.5 20.5H50V21.5H51L50.9849 22.5H61V19.5H55V15.5H58V11.5H55V7.5H61V4.5H52.6754L51 7.0904V17.5ZM10 22.5H3V4.5H10.4627L12 8.18956V12L13.0298 14.5V17.5H11.5L10 20V22.5Z" fill="currentColor"></path><path d="M30.612 14.8383H34.3135L37.0896 22.2413H34.005L32.4627 18.2313L30.9205 22.2413H27.8359L30.612 14.8383Z" fill="currentColor"></path><path d="M37.3981 23.1667L38.9403 27.7935L36.7811 31.1866L34.6219 25.3259L37.3981 23.1667Z" fill="currentColor"></path><path d="M27.5274 23.1667L30.3035 25.3259L28.1443 31.1866L25.9851 27.7935L27.5274 23.1667Z" fill="currentColor"></path></svg>`;

const contentRegExp = /<svg(.*?)>(.*?)<\/svg>/s;
const attrRegExp = /(.*?)="(.*?)"/;
const splitAttrExp = /[\w-]+="[^"]*"/g;

const attributeMap = {
  viewbox: "viewBox",
  class: "className",
};

let instanceId = 0;

function Icon(props) {
  const [, attrs, content] = svg.match(contentRegExp);

  const svgAttributes = {};

  for (const stringAttr of attrs.trim().match(splitAttrExp)) {
    let [, key, value] = stringAttr.match(attrRegExp);
    if (key in attributeMap) key = attributeMap[key];
    svgAttributes[key] = value;
  }

  const [obj, setObj] = useState({ svgAttributes, __html: content });

  // On the client, unique IDs are necessary per instance.
  // We will use the fact that React SSR does not run effects!
  useEffect(() => {
    const ids = svg.matchAll(/id="(.*?)"/gm);
    let html = obj.__html;

    for (const [match, id] of ids) {
      const uniqueID = `${id}-${instanceId}`;
      html = html
        .replace(match, 'id="' + uniqueID + '"')
        .replaceAll(`url(#${id})`, `url(#${uniqueID})`)
        .replaceAll(`"#${id}"`, `"#${uniqueID}"`);
    }

    setObj({ svgAttributes, __html: html });

    instanceId++;
  }, []);

  return (
    <svg
      dangerouslySetInnerHTML={obj}
      {...obj.svgAttributes}
      {...props}
    />
  );
}

export default Object.assign(Icon, { svg });
